module.exports = __webpack_public_path__ + "static/img/wdhj1-1.0fc645c.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhj1-1.png
// module id = 862
// module chunks = 0